import AdapterService from '@/creditflowresearch/domain/Header/Section/AdapterService';
import TransformerService from '@/creditflowresearch/domain/Header/Section/TransformerService';
import ValidationService, { ISectionValidationResult } from '@/creditflowresearch/domain/Header/Section/ValidationService';
import { ISection } from '@creditflowresearch/uilib/Section';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';
import { IMenuProfile } from '@/creditflowresearch/domain/DictionaryMapping';

interface ITransformOptions {
  activeProductAbbreviation: string,
  activeRegionAbbreviation: string,
  activeMapping: HeaderMappingItem,
  filterType: string,
}

class Section {
  static flattenSectionsGrid(sectionsGrid: ISection[][][]): ISection[] {
    return AdapterService.flattenSectionsGrid(sectionsGrid);
  }

  static combineRowsForDesktop(sectionsGrid: ISection[][][]): ISection[][][] {
    return AdapterService.combineRowsForDesktop(sectionsGrid);
  }

  static transformProfilesToSections(
    profilesMenu: IMenuProfile[][][],
    options: ITransformOptions,
  ): ISection[][][] {
    return TransformerService.transformProfilesToSections(profilesMenu, options);
  }

  static validateSectionData(
    mapping: Record<string, HeaderMappingItem>,
    panelId: string,
    isHeaderInitialized: boolean,
    regionId: string,
    sectorsMenu: IMenuProfile[][][],
    industriesMenu: IMenuProfile[][][],
  ): ISectionValidationResult {
    return ValidationService.validateSectionData(
      mapping,
      panelId,
      isHeaderInitialized,
      regionId,
      sectorsMenu,
      industriesMenu,
    );
  }
}

export default Section;
